module.exports = __webpack_public_path__ + "img/goal-seventeen-br.21af4f18.png";